import Vue from 'vue'
import settings from '../settings.coffee'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import change_password from '../core/change_password_part.vue'
import Users_account from '../views/Users/Users_account.vue'
import Dashboard from '../views/Dashboard.vue'
import Distributor_stats from '../views/Distributor_stats.vue'
import Distributor_roles from '../views/Distributor_roles.vue'
import Distributor_add_company from '../views/Distributor_add_company.vue'
import Distributor_companies_list from '../views/Distributor_companies_list.vue'
import Company_informations from '../views/Company/Company_informations.vue'
import Company_company from '../views/Company/Company_company.vue'
import Company_establishments from '../views/Company/Company_establishments.vue'
import Company_establishments_edition from '../views/Company/Company_establishments_edition.vue'
import Company_jobs from '../views/Company/Company_jobs.vue'
import Company_jobs_edition from '../views/Company/Company_jobs_edition.vue'
import Company_skills from '../views/Company/Company_skills.vue'
import Company_recruitments from '../views/Company/Company_recruitments.vue'
import Company_recruitments_edition from '../views/Company/Company_recruitments_edition.vue'
import Company_hierarchy from '../views/Company/Company_hierarchy.vue'
import Company_users_informations from '../views/Company/Company_users_informations.vue'
import Company_abs_tel from '../views/Company/Company_abs_tel.vue'
// import Company_holidays from '../views/Company/Company_holidays.vue'
import Company_telework from '../views/Company/Company_telework.vue'
import Company_absences from '../views/Company/Company_absences.vue'
import Company_oncall_duties from '../views/Company/Company_oncall_duties.vue'
import Company_formations from '../views/Company/Company_formations.vue'
import Company_interviews from '../views/Company/Company_interviews.vue'
import Company_interviews_history from '../views/Company/Company_interviews_history.vue'
import Company_interviews_campaigns from '../views/Company/Company_interviews_campaigns.vue'
import Company_pro_hazards from '../views/Company/Company_pro_hazards.vue'
import Company_elections from '../views/Company/Company_elections.vue'
import Company_variable_payroll from '../views/Company/Company_variable_payroll.vue'
import Company_variable_payroll_sending from '../views/Company/Company_variable_payroll_sending.vue'
import Company_accounting_software_sync from '../views/Company/Company_accounting_software_sync.vue'
import Users_informations from '../views/Users/Users_informations.vue'
import Users_profile from '../views/Users/Users_profile.vue'
import Users_vouchers from '../views/Users/Users_vouchers.vue'
import Users_jobs from '../views/Users/Users_jobs.vue'
import Users_salaries from '../views/Users/Users_salaries.vue'
import Users_pay_slips from '../views/Users/Users_pay_slips.vue'
import Users_graduates from '../views/Users/Users_graduates.vue'
import Users_skills from '../views/Users/Users_skills.vue'
import Users_abs_tel from '../views/Users/Users_abs_tel.vue'
// import Users_holidays from '../views/Users/Users_holidays.vue'
import Users_telework from '../views/Users/Users_telework.vue'
import Users_absences from '../views/Users/Users_absences.vue'
import Users_oncall_duties from '../views/Users/Users_oncall_duties.vue'
import Users_formations from '../views/Users/Users_formations.vue'
import Users_interviews from '../views/Users/Users_interviews.vue'
import Users_interviews_requests from '../views/Users/Users_interviews_requests.vue'
import Users_interviews_coming from '../views/Users/Users_interviews_coming.vue'
// import Users_pro_hazards from '../views/Users/Users_pro_hazards.vue'  # deprecated
import Users_variable_payroll from '../views/Users/Users_variable_payroll.vue'
import Contact_details from '../views/Contact_details.vue'
import Planning from '../views/Planning.vue'
import GED from '../views/GED.vue'
import Company_roles from '../views/Company/Company_roles.vue'
import Company_stats from '../views/Company/Company_stats.vue'
import Exports from '../views/Exports.vue'
import Imports from '../views/Imports.vue'
import Imports_upload from '../views/Imports_upload.vue'
import Imports_configuration from '../views/Imports_configuration.vue'

import store from '@/store/index.js'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login/:next?',
        name: 'login',
        component: Login,
        meta: {
            "auth_required": false
        },
    },
    {
        path: '/change_password/:token_uid',
        name: 'change_password',
        props: true,
        component: change_password,
        meta: {
            "auth_required": false
        },
    },
    {
        path: '/mon_compte',
        name: 'users_account',
        component: Users_account,
        meta: {
            "auth_required": true
        }
    },
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            "auth_required": true
        }
    },
    {
        path: '/distributeur/statistiques_globales',
        name: 'distributor_stats',
        component: Distributor_stats,
        meta: {
            "auth_required": true,
            "distributor": true
        },
    },
    {
        path: '/distributeur/roles_par_defaut',
        name: 'distributor_roles',
        component: Distributor_roles,
        meta: {
            "auth_required": true,
            "distributor": true
        },
    },
    {
        path: '/distributeur/ajouter_societe',
        name: 'distributor_add_company',
        component: Distributor_add_company,
        meta: {
            "auth_required": true,
            "distributor": true
        },
    },
    {
        path: '/distributeur/gerer_societes',
        name: 'distributor_companies_list',
        component: Distributor_companies_list,
        meta: {
            "auth_required": true,
            "distributor": true
        },
    },
    {
        path: '/ma_societe/informations',
        name: 'company_informations',
        component: Company_informations,
        meta: {
            "auth_required": true
        },
        children: [
            {
                path: 'societe/:uid',
                name: 'company_company',
                component: Company_company,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'etablissements',
                name: 'company_establishments',
                component: Company_establishments,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'etablissements/edition/:uid',
                name: 'company_establishments_edition',
                component: Company_establishments_edition,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'metiers',
                name: 'company_jobs',
                component: Company_jobs,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'metiers/edition/:uid',
                name: 'company_jobs_edition',
                component: Company_jobs_edition,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'competences',
                name: 'company_skills',
                component: Company_skills,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'recrutements',
                name: 'company_recruitments',
                component: Company_recruitments,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'recrutements/edition/:uid',
                name: 'company_recruitments_edition',
                component: Company_recruitments_edition,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
        ]
    },
    {
        path: '/ma_societe/collaborateurs/hierarchie',
        name: 'company_hierarchy',
        component: Company_hierarchy,
        meta: {
            "auth_required": true
        },
    },
    {
        path: '/ma_societe/collaborateurs/informations/',
        name: 'company_users_informations',
        component: Company_users_informations,
        props: true,
        meta: {
            "auth_required": true
        },
        children: [
            {
                path: 'profil/:uid',
                name: 'company_users_profile',
                component: Users_profile,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'pieces_justificatives/:uid',
                name: 'company_users_vouchers',
                component: Users_vouchers,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'contrats/:uid',
                name: 'company_users_jobs',
                component: Users_jobs,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'remunerations/:uid',
                name: 'company_users_salaries',
                component: Users_salaries,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'bulletins_de_salaire/:uid',
                name: 'company_users_pay_slips',
                component: Users_pay_slips,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'qualifications/:uid',
                name: 'company_users_graduates',
                component: Users_graduates,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'competences/:uid',
                name: 'company_users_skills',
                component: Users_skills,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
        ]
    },
    {
        path: '/ma_societe/abs_tel',
        name: 'company_abs_tel',
        component: Company_abs_tel,
        meta: {
            "auth_required": true
        },
        children: [
            {
                path: 'absences',
                name: 'company_absences',
                component: Company_absences,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'teletravail',
                name: 'company_telework',
                component: Company_telework,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'astreintes',
                name: 'company_oncall_duties',
                component: Company_oncall_duties,
                meta: {
                    "auth_required": true
                },
            },
        ]
    },
    {
        path: '/ma_societe/formations',
        name: 'company_formations',
        component: Company_formations,
        meta: {
            "auth_required": true
        },
    },
    {
        path: '/ma_societe/entretiens',
        name: 'company_interviews',
        component: Company_interviews,
        meta: {
            "auth_required": true
        },
        children: [
            {
                path: 'historique',
                name: 'company_interviews_history',
                component: Company_interviews_history,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'campagnes',
                name: 'company_interviews_campaigns',
                component: Company_interviews_campaigns,
                meta: {
                    "auth_required": true
                },
            },
        ]
    },
    {
        path: '/ma_societe/risques_professionnels',
        name: 'company_pro_hazards',
        component: Company_pro_hazards,
        meta: {
            "auth_required": true
        },
    },
    {
        path: '/ma_societe/elections',
        name: 'company_elections',
        component: Company_elections,
        meta: {
            "auth_required": true
        },
    },
    {
        path: '/ma_societe/variables_de_paie',
        name: 'company_variable_payroll',
        component: Company_variable_payroll,
        props: true,
        meta: {
            "auth_required": true
        },
    },
    {
        path: '/ma_societe/variables_de_paie_envoi',
        name: 'company_variable_payroll_sending',
        component: Company_variable_payroll_sending,
        props: true,
        meta: {
            "auth_required": true
        },
    },
    {
        path: '/ma_societe/synchronisation_logiciel_paie',
        name: 'company_accounting_software_sync',
        component: Company_accounting_software_sync,
        meta: {
            "auth_required": true
        },
    },
    {
        path: '/mon_profil/informations',
        name: 'users_informations',
        component: Users_informations,
        props: true,
        meta: {
            "auth_required": true
        },
        children: [
            {
                path: 'profil/:uid',
                name: 'users_profile',
                component: Users_profile,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'pieces_justificatives/:uid',
                name: 'users_vouchers',
                component: Users_vouchers,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'contrats/:uid',
                name: 'users_jobs',
                component: Users_jobs,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'remunerations/:uid',
                name: 'users_salaries',
                component: Users_salaries,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'bulletins_de_salaire/:uid',
                name: 'users_pay_slips',
                component: Users_pay_slips,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'qualifications/:uid',
                name: 'users_graduates',
                component: Users_graduates,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'competences/:uid',
                name: 'users_skills',
                component: Users_skills,
                props: true,
                meta: {
                    "auth_required": true
                },
            },
        ]
    },
    {
        path: '/mon_profil/abs_tel',
        name: 'users_abs_tel',
        component: Users_abs_tel,
        meta: {
            "auth_required": true
        },
        children: [
            {
                path: 'absences',
                name: 'users_absences',
                component: Users_absences,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'teletravail',
                name: 'users_telework',
                component: Users_telework,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'astreintes',
                name: 'users_oncall_duties',
                component: Users_oncall_duties,
                meta: {
                    "auth_required": true
                },
            },
        ]
    },
    {
        path: '/mon_profil/formations',
        name: 'users_formations',
        component: Users_formations,
        meta: {
            "auth_required": true
        },
    },
    // {
    //     path: '/mon_profil/risques_professionnels',
    //     name: 'users_pro_hazards',
    //     component: Users_pro_hazards,
    //     meta: {
    //         "auth_required": true
    //     },
    // },
    {
        path: '/mon_profil/variables_de_paie',
        name: 'users_variable_payroll',
        component: Users_variable_payroll,
        meta: {
            "auth_required": true
        },
    },
    {
        path: '/mon_profil/entretiens',
        name: 'users_interviews',
        component: Users_interviews,
        meta: {
            "auth_required": true
        },
        children: [
            {
                path: 'demandes',
                name: 'users_interviews_requests',
                component: Users_interviews_requests,
                meta: {
                    "auth_required": true
                },
            },
            {
                path: 'a_venir',
                name: 'users_interviews_coming',
                component: Users_interviews_coming,
                meta: {
                    "auth_required": true
                },
            },
        ]
    },
    {
        path: '/outils/annuaire',
        name: 'contact_details',
        component: Contact_details,
        meta: {
            "auth_required": true
        },
    },
    {
        path: '/outils/planning',
        name: 'planning',
        component: Planning,
        meta: {
            "auth_required": true
        },
    },
    {
        path: '/outils/gestion_des_documents',
        name: 'ged',
        component: GED,
        meta: {
            "auth_required": true
        },
    },
    {
        path: '/outils/gestion_des_roles',
        name: 'company_roles',
        component: Company_roles,
        meta: {
            "auth_required": true
        },
    },
    {
        path: '/statistiques/collaborateurs',
        name: 'company_stats',
        component: Company_stats,
        meta: {
            "auth_required": true
        },
    },
    {
        path: '/exports',
        name: 'exports',
        component: Exports,
        meta: {
            "auth_required": true
        },
    },
    {
        path: '/imports',
        name: 'imports',
        component: Imports,
        props: true,
        meta: {
            "auth_required": true
        },
    },
    {
        path: '/imports_upload',
        name: 'imports_upload',
        component: Imports_upload,
        props: true,
        meta: {
            "auth_required": true
        },
    },
    {
        path: '/imports/configuration',
        name: 'imports_configuration',
        component: Imports_configuration,
        props: true,
        meta: {
            "auth_required": true
        },
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // }
]


var router = new VueRouter({
    mode: 'history',
    linkExactActiveClass: 'active',
    linkActiveClass: 'active',
    base: process.env.BASE_URL,
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    // stringifyQuery (query) {
    //     console.log("STRINGIFY QUERY", Object.keys(query))
    //     // return query ? query : ''
    // }
})

router.beforeEach(function (to, from, next){
    // console.log("BEFORE", store.state.authenticated, localStorage.getItem("authenticated"))

    // console.log("TO : ", to)
    // console.log("FROM : ", from)
    // console.log("COOKIE : ", Vue.cookie.get('csrftoken_dj'))

    // if(localStorage.getItem("authenticated") == "false" || localStorage.getItem("authenticated") == null){
    //     console.log("LOCAL AUTHENTICATE FALSE OR NULL")
    //     store.commit("not_authenticate")
    // }
    // if(!store.state.authenticated && to.meta.auth_required){
    //     console.log("STORE AUTHENTICATE FALSE")
    //     router.push({ name: "login", params: { "next": to.path } })
    //     console.log("you must be authenticated", to.path, from.path)
    // }
    // else{
    //     next()
    // }

    if(localStorage.getItem("authenticated") == "false" || localStorage.getItem("authenticated") == null || Vue.cookie.get('csrftoken_dj') == null){
        // console.log("LOCAL AUTHENTICATE FALSE OR NULL")
        store.commit("not_authenticate")
    }
    // if(store.state.authenticated && Vue.cookie.get('csrftoken_dj') == null){
    //     console.log("COOKIE NULL", store.state.authenticated)
    //     console.log("COOKIE NULL", Vue.cookie.get('csrftoken_dj') == null)
    //     console.log("COOKIE NULL", from.name != 'login')
    //     Vue.prototype.$notify.error({
    //         title:"Vous n'êtes plus authentifié⋅e",
    //         message:"Vous allez être redirigé⋅e vers la page de connexion",
    //         duration:3000,
    //         offset:100
    //     })
    //     store.commit("not_authenticate")
    //     setTimeout(function(){
    //         router.replace({name: 'login'})
    //     }, 3000)
    // }
    if(!store.state.authenticated && to.meta.auth_required){
        // console.log('!!ROUTER store false / meta.auth_required')
        Vue.http.get(settings.login_url)
        .then((resp)=>{
            if(resp.body.status == "loggedin"){
                store.dispatch('set_authenticated', resp.body.datas)
                // console.log('!!ROUTER loggedin', to.path)
                if(localStorage.getItem('selected_company') != null && JSON.parse(localStorage.getItem('selected_company')).uid != ''){
                    // console.log('!!ROUTER in localStorage', to.path)
                    router.push({path: to.path || '/'})
                    .catch(function(err){})
                }
                else{
                    router.push({path: '/'})
                    .catch(function(err){})
                }
            }
            else{
                // console.log("STORE AUTHENTICATE FALSE cookie csrf before set: ", Vue.cookie.get('csrftoken'))
                // Vue.cookie.set('csrftoken', resp.body.token)
                // console.log("STORE AUTHENTICATE FALSE cookie csrf after set: ", Vue.cookie.get('csrftoken'))
                // back to login !
                console.log("you must be authenticated", to.path, from.path)
                if(to.name != 'dashboard' && to.name != 'login'){
                    router.push({ name: "login", params: { "next": to.path } })
                    .catch(function(err){})
                }
                else{
                    router.push({ name: "login"})
                    .catch(function(err){})
                }
            }
        })
    }
    else if(store.state.authenticated && to.meta.distributor){
        var admin = store.state.user_datas.profiles.indexOf('distributor') != -1 || store.state.user_datas.profiles.indexOf('superadmin') != -1
        // console.log('ADMIN ROUTER ', admin)
        if(!admin){
            router.push({name:"dashboard"})
            .catch(function(err){})
        }
        else{
            next()
        }
    }
    else{
        next()
    }
})

export default router
